import script from "./ordersInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ordersInfo.vue?vue&type=script&setup=true&lang=js"

import "./ordersInfo.vue?vue&type=style&index=0&id=441fc201&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-441fc201"]])

export default __exports__